import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import * as cafeActions from '../../redux/cafes/actions';

const RseeDiscountRequestsFilter = props => {
  let { onSelectCafeIds } = props;

  let formRefrence = useRef();
  let [cafeIds, setCafeIds] = useState([]);

  useEffect(() => {
    props.getAllCafeNamesForPanel();
  }, []);

  const resetForm = event => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.type === 'radio' || element.type === 'checkbox') {
        element.checked = null;
      } else if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setCafeIds([]);
    onSelectCafeIds([]);
    props.applyFilters(event);
  };

  return (
    <article>
      <form
        ref={formRefrence}
        onReset={event => resetForm(event)}
        onSubmit={event => props.applyFilters(event)}
        id="filterForm"
        className="card card my-4"
      >
        <header className="text-center card-header">
          <h5 className="font-italic text-muted">{locales('titles.filter')}</h5>
        </header>
        <main className="card-body">
          <div className="d-flex justidy-content-between px-1">
            <Select
              id="cafeIds"
              name="cafeIds"
              isMulti={true}
              value={cafeIds}
              onChange={selectedCafeIds => {
                setCafeIds(selectedCafeIds);
                onSelectCafeIds(selectedCafeIds);
              }}
              className="col-6 mx-1"
              options={props.cafeNamesList.map(n => ({
                label: n.name,
                value: n.id
              }))}
              placeholder={locales('fields.cafe.name')}
            />
          </div>
          <div className="col-12 d-flex justify-content-end p-0">
            {/* <input
              type="checkbox"
              value={cafeStatus.value}
              name={`status`}
              id={`status-${index}`}
              className=""
            /> */}
            <input
              name="resetButton"
              type="reset"
              value={locales('fields.reset')}
              className="btn btn-danger w-5 mx-2"
            />
            <button
              type="submit"
              id="apply-filter-btn-rseeDiscountRequests"
              className="btn btn-success w-5 mx-2"
            >
              {locales('fields.applyFilters')}
            </button>
          </div>
        </main>
      </form>
    </article>
  );
};

const mapStateToProps = state => {
  return {
    cafeNamesLoading: state.cafesReducer.cafeNamesLoading,
    cafeNamesList: state.cafesReducer.cafeNamesList,
    cafeNames: state.cafesReducer.cafeNames,
    cafeNamesFailed: state.cafesReducer.cafeNamesFailed,
    cafeNamesMessage: state.cafesReducer.cafeNamesMessage,
    cafeNamesError: state.cafesReducer.cafeNamesError,

    cafeNamesListLoading: state.cafesReducer.cafeNamesListLoading,
    cafeNamesListFailed: state.cafesReducer.cafeNamesListFailed,
    cafeNamesListMessage: state.cafesReducer.cafeNamesListMessage,
    cafeNamesListError: state.cafesReducer.cafeNamesListError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getAllCafeNamesForPanel: () => dispatch(cafeActions.getAllCafeNamesForPanel())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RseeDiscountRequestsFilter);
